import type { IconSvgObject } from './types';

const Image01Icon: IconSvgObject = [
  ["circle", { cx: "8", cy: "8", r: "1.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 21.5L14.3453 13.5393C15.0247 12.9278 16.0321 12.8547 16.7926 13.3617L21.5 16.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default Image01Icon;
